/**
 * Check if OCR metadata indicates the photo has expired
 * Returns true if expired or no valid expiry date, false if still valid
 */
export const isPhotoExpired = (
  ocrMetadata: Record<string, unknown> | null | undefined,
): boolean => {
  if (!ocrMetadata?.expirationDate) return true; // No expiry = treat as expired

  const expiryDateStr = ocrMetadata.expirationDate as string;
  const expiryDate = new Date(expiryDateStr);

  if (Number.isNaN(expiryDate.getTime())) return true; // Invalid date = treat as expired

  return expiryDate < new Date(); // True if expired
};
